module.exports = __webpack_public_path__ + "static/media/footer-img1.31d3fc30.jpg";